import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { updateSubscription } from "../../../redux/reducers/postApiSlice";
import { formatDateTimezonYYMMDD } from "../../common-data/Converts";
import { showConfirmAlert } from "../../components-react/ReactAlert";

const EditImportMemDate = ({
  userInfoData,
  rowData,
  callFunction,
  onCloseModal,
}) => {
  const dispatch = useDispatch();

  const initialCreateSubsFormData = {
    enteredStartDate: rowData?.start_date
      ? formatDateTimezonYYMMDD(rowData.start_date)
      : "",
    enteredExpireDate: rowData?.expire_date
      ? formatDateTimezonYYMMDD(rowData.expire_date)
      : rowData?.end_date
      ? rowData.end_date
      : "",
  };
  const [createSubsFormData, setCreateSubsFormData] = useState(
    initialCreateSubsFormData
  );
  const [createSubsFormErrors, setCreateSubsFormErrors] = useState({});
  const [isSubsFormTrue, setIsSubsFormTrue] = useState(false);

  const onClickSubmit = (e) => {
    e.preventDefault();

    setCreateSubsFormErrors(validateSubscriptionForm(createSubsFormData));
    setIsSubsFormTrue(true);
  };

  const handleEditSubscription = async (userData, TOKEN) => {
    setIsSubsFormTrue(false);
    try {
      const actionResult = dispatch(updateSubscription({ userData, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");

        setCreateSubsFormData(initialCreateSubsFormData);
        setCreateSubsFormErrors({});
        callFunction();
        onCloseModal();
      } else {
        const errorMessage = result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleEditSubscription ERROR => ", error);
    }
  };

  const validateSubscriptionForm = (createSubsFormData) => {
    let errors = {};

    if (!createSubsFormData.enteredStartDate) {
      errors.enteredStartDate = "Subscription start date required!";
    }

    if (!createSubsFormData.enteredExpireDate) {
      errors.enteredExpireDate = "Subscription expire date required!";
    }

    if (
      createSubsFormData.enteredStartDate &&
      createSubsFormData.enteredExpireDate &&
      new Date(createSubsFormData.enteredStartDate) >
        new Date(createSubsFormData.enteredExpireDate)
    ) {
      errors.enteredStartDate = "Subscription start date required!";
      errors.enteredExpireDate = "Subscription expire date required!";
    }

    return errors;
  };

  useEffect(() => {
    if (isSubsFormTrue && Object.keys(createSubsFormErrors)?.length === 0) {
      const userData = {
        subscription_id: rowData?.uid || "",
        user_id: rowData?.user_id || "",
        gym_id: rowData?.gym_id || "",
        start_date: createSubsFormData.enteredStartDate || "",
        end_date: createSubsFormData.enteredExpireDate || "",
        status: rowData?.subscription_status || "",
      };

      const handleConfirm = async () => {
        handleEditSubscription(userData, userInfoData?.token);
      };

      showConfirmAlert(
        handleConfirm,
        `Check Dates Again!`,
        "No, Cancel",
        "Yes, proceed"
      );
    } else {
      setIsSubsFormTrue(false);
    }
  }, [isSubsFormTrue]);

  return (
    <div className="paymentLinkForm">
      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="enteredStartDate" className="formInputLabel">
              Subscription Start Date <span className="required">*</span>
            </label>

            <input
              type="date"
              className={`formInput ${
                createSubsFormErrors.enteredStartDate ? "formError" : ""
              } ${createSubsFormData.enteredStartDate ? "date-has-value" : ""}`}
              name="enteredStartDate"
              value={createSubsFormData.enteredStartDate}
              onChange={(e) =>
                setCreateSubsFormData({
                  ...createSubsFormData,
                  enteredStartDate: e.target.value,
                })
              }
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="enteredExpireDate" className="formInputLabel">
              Subscription Expire Date <span className="required">*</span>
            </label>

            <input
              type="date"
              className={`formInput ${
                createSubsFormErrors.enteredExpireDate ? "formError" : ""
              } ${
                createSubsFormData.enteredExpireDate ? "date-has-value" : ""
              }`}
              name="enteredExpireDate"
              value={createSubsFormData.enteredExpireDate}
              onChange={(e) =>
                setCreateSubsFormData({
                  ...createSubsFormData,
                  enteredExpireDate: e.target.value,
                })
              }
            />
          </div>
        </div>

        <div
          className="formButtons"
          style={{ justifyContent: "flex-end", marginTop: "20px" }}
        >
          <Button className="saveBtn" variant="danger" onClick={onClickSubmit}>
            Edit Subscription
          </Button>
        </div>
      </form>
    </div>
  );
};

export default EditImportMemDate;
